import React, { useState, useEffect } from 'react';
import apiService from '../services/api.service';
import authService from '../services/auth.service';
import SuppliersList from './SuppliersList';
import SupplierCategories from './SupplierCategories';
import Products from './Products';
import './Suppliers.css';
import Orders from './Orders';
import Payments from './Payments';

const Suppliers = () => {
  // State for tab management
  const [activeTab, setActiveTab] = useState('suppliers'); // 'suppliers', 'categories', or 'products'
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Admin check
  const isAdmin = authService.getUser()?.role === 'admin';

  useEffect(() => {
    // Admin check
    if (!isAdmin) {
      setError('You do not have permission to access this page.');
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [isAdmin]);

  // API connection test
  const testApiConnection = async () => {
    try {
      console.log('Starting API test...');
      const response = await apiService.get('/api/suppliers');
      console.log('API test response:', response);
      alert('API connection test successful!');
    } catch (err) {
      console.error('API test error:', err);
      alert(`API connection test failed! Error: ${err.message}`);
    }
  };

  // If not admin, show access denied message
  if (!isAdmin) {
    return (
      <div className="suppliers">
        <div className="error-message">
          You do not have permission to access this page. Please log in with an admin account.
        </div>
      </div>
    );
  }

  return (
    <div className="suppliers">
      <div className="section-header">
        <h2>Supply Management</h2>
        <div>
          <button
            className="test-button"
            onClick={testApiConnection}
            title="Test API Connection"
          >
            API Test
          </button>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="tabs">
        <button 
          className={`tab-button ${activeTab === 'suppliers' ? 'active' : ''}`}
          onClick={() => setActiveTab('suppliers')}
        >
          Suppliers
        </button>
        <button 
          className={`tab-button ${activeTab === 'categories' ? 'active' : ''}`}
          onClick={() => setActiveTab('categories')}
        >
          Categories
        </button>
        <button 
          className={`tab-button ${activeTab === 'products' ? 'active' : ''}`}
          onClick={() => setActiveTab('products')}
        >
          Products
        </button>
        <button 
          className={`tab-button ${activeTab === 'orders' ? 'active' : ''}`}
          onClick={() => setActiveTab('orders')}
        >
          Siparişler
        </button>

        <button 
          className={`tab-button ${activeTab === 'payments' ? 'active' : ''}`}
          onClick={() => setActiveTab('payments')}
        >
          Ödemeler
        </button>
      </div>

      {loading ? (
        <div className="loading">Loading...</div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : (
        <>
          {/* Suppliers Tab */}
          {activeTab === 'suppliers' && <SuppliersList />}

          {/* Categories Tab */}
          {activeTab === 'categories' && <SupplierCategories />}

          {/* Products Tab */}
          {activeTab === 'products' && <Products />}

          {/* Orders Tab */}
          {activeTab === 'orders' && <Orders />}

          {/* Payments Tab */}
          {activeTab === 'payments' && <Payments />}
        </>
      )}
    </div>
  );
};

export default Suppliers;